var _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFlagCa = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 21,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  role: "img"
}, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "flag-ca_svg__a",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 21,
  height: 16
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.94.5h20v15h-20z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#flag-ca_svg__a)",
  fillRule: "evenodd",
  clipRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.94.5h10v15h-10V.5Z",
  fill: "#F7FCFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "m9.896 5.752 1.028-1.502.016 8.75h-.428l.263-2.165s-2.882.529-2.644.262.375-.757.375-.757L5.94 8.592s.405-.005.734-.205c.33-.2-.329-1.385-.329-1.385l1.296.192.49-.544.977 1.045h.44l-.44-2.393.788.45ZM10.94 13V4.25l1.045 1.502.787-.45-.439 2.393h.44l.977-1.045.49.544 1.296-.192s-.659 1.185-.33 1.385c.33.2.734.205.734.205l-2.566 1.748s.138.49.376.757-2.644-.262-2.644-.262L11.369 13h-.429Z",
  fill: "#E31D1C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.94.5h5v15h-5V.5ZM.94.5h5v15h-5V.5Z",
  fill: "#E31D1C"
}))));
export default SvgFlagCa;